import { render, staticRenderFns } from "./UsersByEntity.vue?vue&type=template&id=048a7f06&"
import script from "./UsersByEntity.vue?vue&type=script&lang=js&"
export * from "./UsersByEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports